/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1TutoraiDocumentsQueryResponse,
  GetApiV1TutoraiDocumentsQueryParams,
  GetApiV1TutoraiDocuments401,
  GetApiV1TutoraiDocuments500,
} from "../../types/tutorAIDocumentosController/GetApiV1TutoraiDocuments.ts";

function getGetApiV1TutoraiDocumentsUrl() {
  const res = { method: "GET", url: `/api/v1/tutorai/documents` as const };
  return res;
}

/**
 * @description Retorna todos os documentos cadastrados para a turma. **(Requer Authorization para autenticação)**
 * @summary Listar documentos (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/documents}
 */
export async function getApiV1TutoraiDocuments(
  params?: GetApiV1TutoraiDocumentsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1TutoraiDocumentsQueryResponse,
    ResponseErrorConfig<
      GetApiV1TutoraiDocuments401 | GetApiV1TutoraiDocuments500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1TutoraiDocumentsUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
